import { render, staticRenderFns } from "./new-board-tab.vue?vue&type=template&id=64f9b3d9"
import script from "./new-board-tab.vue?vue&type=script&lang=js"
export * from "./new-board-tab.vue?vue&type=script&lang=js"
import style0 from "./new-board-tab.vue?vue&type=style&index=0&id=64f9b3d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports